import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useEffect, useState } from "react";

import { getFaqs } from "../../api/faq/getFaqs";
import FaqListCard from "../../faq/components/FaqListCard";
import { removeDuplicatesByKey } from "../../helpers/array";
import { useFaqs } from "../../hooks/useFaqs";
import { APPage, CRMAppLocationIdentifier, Faq } from "../../types/Faq";
import { FaqContextIds } from "../AppLocation";

interface FaqListProps {
  pageId: APPage;
  appLocationIdentifier: CRMAppLocationIdentifier;
  faqContextIds?: FaqContextIds;
}

const FaqList = ({
  pageId,
  appLocationIdentifier,
  faqContextIds,
}: FaqListProps) => {
  const [appLocationId, setAppLocationId] = useState<string | null>(null);

  const {
    faqProps,
    contextIds,
    isLoading: isLoadingFaqs,
    isSuccess: isSuccessFaqs,
  } = useFaqs({
    pageId,
    quoteId: faqContextIds?.quoteId,
    contextIds: faqContextIds,
  });

  const faqs = getFaqs(
    { appLocationId: appLocationId || "", quoteId: faqContextIds?.quoteId },
    {
      disabled: !appLocationId,
    }
  );

  useEffect(() => {
    if (isSuccessFaqs) {
      const appLocation = faqProps.faqAppLocations.find(
        (location) => location.appLocationIdentifier === appLocationIdentifier
      );

      if (appLocation) {
        setAppLocationId(appLocation.id);
      }
    }
  }, [isSuccessFaqs, appLocationIdentifier, faqProps.faqAppLocations]);

  const isSuccess = faqs.isSuccess;
  const isLoading = isLoadingFaqs || faqs.isLoading;

  const renderFaq = (faq: Faq) => {
    return (
      <FaqListCard
        key={`list-${faq.id}`}
        faq={faq}
        appLocationId={appLocationId || ""}
        contextIds={contextIds || {}}
      />
    );
  };

  const filteredFaqs = faqs.data ? removeDuplicatesByKey(faqs.data, "id") : [];

  return (
    <Box>
      {isSuccess && !isLoading && (
        <Stack spacing={1}>{filteredFaqs.map(renderFaq)}</Stack>
      )}
    </Box>
  );
};

export default FaqList;
